
import './About_us.css';
import './Products.css';
import "../components/Header.css";
import Header from '../components/Header.js';
import Footer from '../components/Footer.js';
import img4 from '../media/images/Tana.jpg'


function About_us() {

  return(
    <div className='About-us-screen'>
    <Header></Header>
    {/* <Navbar></Navbar> */}
    <main className='About-us-main-container'>
        <div className='About-us-left-side'>

          <div className='Tanas-image-container'>
            <img className='Tanas-img' src={img4} alt="Tana"></img>
          </div>

        </div>


        <div className='About-us-right-side'>
          
          <div className='About-us-paragraph-container'>
            <p>Fresh, Fun, and Fruitful</p>
            <p>
              <strong>The begginings </strong>
            </p>

            <p>
              Here at Tana's arrangements its a one man show, well one women show.
              I've always had a deep-rooted passion for the vibrant colors and sweet flavors 
              of fresh fruit. It's more than just food; it's a form of art. I find joy in 
              transforming simple fruits into stunning arrangements. Each piece is a testament 
              to nature's beauty and my creative spirit. Whether it's a towering 
              fruit bouquet or a miniature fruit sculpture, I strive to create edible 
              masterpieces that will delight your eyes and excite your taste buds. 
            </p>


            <p>
              <strong>The face behind the fruit </strong>
            </p>

            <p>Well, the face behind the fruit is me Tatjana.
               Of course, with the support of the family.
               </p>
            
            <p>
              <strong>Smiles Guarentee </strong>
            </p>

            <p>We strive to deliver as many smiles as possible. It's what we do, 
              we are commited and passionate to deliver you with superb experince. In fact,
              if you are not sattisfied, call us and we will make it right </p>


            <p>
              <strong>Our Values </strong>
            </p>
            <li className='About-us-values'>Smiles on smiles</li>
            <li className='About-us-values'>Freshness</li>
            <li className='About-us-values'>Quality</li>
            <li className='About-us-values'>Creativity</li>
            <li className='About-us-values'>Costumer Satisfaction</li>

          </div>
        </div>
    </main>
    <Footer></Footer>
</div>
  );

  }
  
  export default About_us;